export default {"src":"/_next/static/image/public/images/ic_bookmark_dark_grey_vertical_menu.c719ebb2e7511a91ace3d1cdf047f7d1.svg","height":20,"width":20};